import { LOCATION_INITIALIZED } from '@angular/common';
import { Injector, inject } from '@angular/core';

import { TranslateService } from 'src/app/core/services/translate/translate.service';

import { DEFAULT_USER_LOCALE } from '../constants';
import { loadTranslations } from '../services/translate/translate.model';

export const ngxTranslationInitializerFactory = () => {
  const translate = inject(TranslateService);
  const injector = inject(Injector);

  const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

  return (async () => {
    await locationInitialized;
    await loadTranslations();
    const langToSet = DEFAULT_USER_LOCALE;
    return new Promise<boolean>(resolve => {
      translate.use(langToSet).subscribe({
        error: _err => {
          // eslint-disable-next-line no-console
          console.log(`Problem with ${langToSet} language initialization.`);
        },
        complete: () => {
          resolve(false);
        },
      });
    });
  })();
};
